// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"ad43458c","621":"e1f80559","743":"73cd447e","881":"6716fdde","917":"4ae0a9fa"}[chunkId] + ".chunk.js";
};